/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Forgot password page
  Date: April 04, 2020
**/

import React from 'react';
import {
  Paper,
  Grid,
  Typography,
  Box,
} from '@material-ui/core';
import { useStoreActions } from 'easy-peasy';
import styles from './forgotPassword.module.scss';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import ConfirmCodeForm from './components/ConfirmCodeForm';

import Header from '../../layout/main/headers/Header';
import Footer from '../../layout/main/footers/Footer';

const ForgotPassword = (props) => {

  const userAction = useStoreActions((actions) => actions.login);
  const comonAction = useStoreActions((actions) => actions.common);

  const [resend, setResend] = React.useState(false);
  const [showMailMsg, setShowMailMsg] = React.useState(false);  
  const [isCheckingUsername, setIsCheckingUsername] = React.useState(false);
  const [isResettingPassword, setIsResettingPassword] = React.useState(false);


  // Set initial values top empty for email and password
  const [forgotData, setForgotData] = React.useState({
    username: '',
    resend: false,
  });

  const [resetPwdData, setResetPwdData] = React.useState({
    username: '',
    code: '',
    passwd: '',
    passwd_confirmation: '',
  });

  React.useEffect(() => {
    if (forgotData && forgotData.username !== '') {
      console.log('setForgotdata... ', forgotData)
      setResetPwdData({...resetPwdData, username: forgotData.username});
    }
  }, [forgotData]);

  const onForgotFormSubmit = async (values, { setErrors }) => {
    if (resend) values.resend = true;

    setIsCheckingUsername(true);

    userAction
      .forgotPassword(values)
      .then((response) => {
        setIsCheckingUsername(false);
        setShowMailMsg(true);
        setResend(true);
      })
      .catch((error) => {
        setIsCheckingUsername(false);
        if (
          error.response && error.response.status && ((error.response.status === 405) ||
          (error.response.status === 422) || (error.response.status === 427))
        ) {
          comonAction.setSubmitSnackbar({
            status: true,
            messages: error.response.data.error,
            error: true,
          });
        } else {
          comonAction.setSubmitSnackbar({
            status: true,
            messages: 'Oops something went wrong. please try again',
            error: true,
          });
        }
      });    
  };

  /**
   * On Reset Password Page submit, trigger a API call
   * @param {object} values username and password
   */
  const onResetFormSubmit = async (values) => {
    setIsResettingPassword(true);

    userAction
      .resetPassword({
      username: values.username,
      code: values.code,
      passwd: values.passwd,
      passwd_confirmation: values.passwd_confirmation
    })
      .then((response) => {
        setIsResettingPassword(false);

        if (response && response.data && response.data.success) {
          comonAction.setSubmitSnackbar({
            status: true,
            messages: response.data.data.message,
            error: false,
          });

          // Auto Navigate to Login page, after 3s

          setTimeout(() => {
            props.history.push('/login');
          }, 3000);
        }
      })
      .catch((error) => {
        setIsResettingPassword(false);
        //console.log('error.response=== ', error.response)        
        if (
          (error.response && error.response.status && error.response.status === 405) ||
          error.response.status === 422 || error.response.status === 427
        ) {
          if (Array.isArray(error.response.data.error)) {
            error.response.data.error.forEach((i) => {
              comonAction.setSubmitSnackbar({
                status: true,
                messages: Object.values(i)[0],
                error: true,
              });
            })
          }
          else {
            comonAction.setSubmitSnackbar({
              status: true,
              messages: error.response.data.error,
              error: true,
            });
          }
        } else {
          comonAction.setSubmitSnackbar({
            status: true,
            messages: 'Oops something went wrong. please try again',
            error: true,
          });
        }
      });
  };


  return (
    <Grid container component="main" style={{ height: '100vh', overflowY: 'scroll' }}>
      <Grid item xs={12} component={Paper} square>
        <Header></Header>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: 'calc(100% - 115px)' }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <Box className={styles['login-wrapper']}>
              <Box
                data-testid="header-text"
                component="h2"
                sx={{ m: 0, fontWeight: 'bold', textAlign: 'center' }}
              >
                Forgot Password
              </Box>
              {showMailMsg && (
                <Typography color="primary" style={{textAlign: 'center'}}>
                  Verification code has been sent to your e-mail address
                </Typography>
              )}
              
              <ForgotPasswordForm resend={resend} forgotData={forgotData} setForgotData={setForgotData} onForgotFormSubmit={onForgotFormSubmit} isLoading={isCheckingUsername} />
              
              {resend && resetPwdData.username && (<ConfirmCodeForm resetPwdData={resetPwdData} onResetFormSubmit={onResetFormSubmit} isLoading={isResettingPassword} setResetPwdData={setResetPwdData} />)}

            </Box>
          </Grid>
        </Grid>
        <Footer></Footer>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
